/**
 * Created by Ning Jiang on 10/4/2018.
 */

import {Background, IBackgroundConfig} from "@nolimitcity/slot-game/bin/core/background/Background";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombstoneGameAssets} from "../TombstoneGameAssets";
import {TombstoneGameConfig} from "../TombstoneGameConfig";

export class TombstoneBackground extends Background {

    private _backgroundSprite_main:PIXI.Sprite;
    private _backgroundSprite_main_bottom:PIXI.Container;
    private _reelBackgroundSprite:PIXI.Sprite;
    private _foregroundSprite_main:PIXI.Sprite;
    private _logo:PIXI.Sprite;

    constructor(config:IBackgroundConfig) {
        super(config);
    }

    protected initAnimations():void {
        super.initAnimations();

        this._backgroundSprite_main = new PIXI.Sprite(GameResources.getTextures(TombstoneGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundSprite_main.anchor.set(0.5, 0.5);
        this.addChild(this._backgroundSprite_main);

        this._backgroundSprite_main_bottom = new PIXI.Container();
        this._backgroundSprite_main_bottom.visible = false;
        this.addChild(this._backgroundSprite_main_bottom);

        const backgroundBottomSprite = new PIXI.Sprite(GameResources.getTextures(TombstoneGameAssets.MAIN_GAME_BACKGROUND)[0]);
        backgroundBottomSprite.anchor.set(0.5, 1);
        this._backgroundSprite_main_bottom.addChild(backgroundBottomSprite);

        const backgroundBottomMask = new PIXI.Graphics();
        backgroundBottomMask.beginFill(0xff0000);
        backgroundBottomMask.drawRect(-this._backgroundSprite_main_bottom.width / 2, -this._backgroundSprite_main_bottom.height / 2, this._backgroundSprite_main_bottom.width, this._backgroundSprite_main_bottom.height / 2);
        this._backgroundSprite_main_bottom.addChild(backgroundBottomMask);
        backgroundBottomSprite.mask = backgroundBottomMask;

        const reelBackgroundLayer:ScalableLayer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        this._reelBackgroundSprite = new PIXI.Sprite(GameResources.getTextures(TombstoneGameAssets.REELS_BACKGROUND)[0]);
        this._reelBackgroundSprite.position.set(162, 45);
        reelBackgroundLayer.addChild(this._reelBackgroundSprite);

        const foregroundLayer:ScalableLayer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.FOREGROUND.name);
        this._foregroundSprite_main = new PIXI.Sprite(GameResources.getTextures(TombstoneGameAssets.MAIN_GAME_FOREGROUND)[0]);
        this._foregroundSprite_main.position.set(-200, -480);
        foregroundLayer.addChild(this._foregroundSprite_main);

    }

    protected onResize(resizeData:IResizeData):void {
        const screenWidth = Math.ceil(resizeData.width / this._layer.scale.x);
        const screenHeight = Math.ceil(resizeData.height / this._layer.scale.y);
        const leftOffset = -this._layer.x / this._layer.scale.x;
        const topOffset = -this._layer.y / this._layer.scale.y;
        if(this._backgroundSprite_main.height >= screenHeight) {
            this._backgroundSprite_main.position.set(screenWidth / 2 + leftOffset, screenHeight / 2 + topOffset);
            this._backgroundSprite_main_bottom.visible = false;
        } else {
            this._backgroundSprite_main.position.set(screenWidth / 2 + leftOffset, this._backgroundSprite_main.height / 2 + topOffset);
            this._backgroundSprite_main_bottom.visible = true;
            this._backgroundSprite_main_bottom.position.set(screenWidth / 2 + leftOffset, screenHeight + topOffset);
        }
    }
}